// import fs from "fs";
// import path from "path";

export const PRESERVE_LOGS = false;

// !! Do not enable for platforms other than web, mobile and chx will crash
// export const permanentLogToFile = ({ query, type, additionalProps, page }) => {
//     const logDirectory = path.join(__dirname.split("/apps/web")[0], "apps/web/webLogs");
//     const logFilePath = path.join(logDirectory, "log.json");

//     // make the file if it doesn't exist
//     if (!fs.existsSync(logDirectory)) fs.mkdirSync(logDirectory);
//     if (!fs.existsSync(logFilePath)) fs.writeFileSync(logFilePath, "[]");

//     const entry = {
//         time: new Date().toISOString(),
//         query,
//         type,
//         additionalProps,
//         page,
//     };

//     const logs = JSON.parse(fs.readFileSync(logFilePath, "utf8"));
//     logs.push(entry);
//     fs.writeFileSync(logFilePath, JSON.stringify(logs, null, 2));
// };

import noop from "./noop";

// !! On Mobile, trying to import fs will crash the app
export const permanentLogToFile = _unused => noop();
